import { Validator } from '@vista-digital/validator';
import { currentPasswordFieldValidationConfigValidator, defaultCurrentPasswordFieldValidationConfig } from '../../../../subcomponents/form/field/current-password/types/validation-config';
import { FieldFormatType } from '../../../../types/form/field-format-type';
import { emailFieldValidationConfigValidatorSchema, otherFieldValidationConfigValidator } from '../../../../types/form/field-validation-config';
export const defaultUpdateMemberEmailFormValidationConfig = {
    currentPassword: defaultCurrentPasswordFieldValidationConfig,
    email: { type: FieldFormatType.Email, required: true },
    captcha: { type: FieldFormatType.Other, required: true }
};
export const updateMemberEmailFormValidationConfigValidator = Validator.object({
    currentPassword: currentPasswordFieldValidationConfigValidator,
    email: Validator.object(Object.assign(Object.assign({}, emailFieldValidationConfigValidatorSchema), { required: Validator.isEqualTo(true) })),
    captcha: otherFieldValidationConfigValidator
});
//# sourceMappingURL=validation-config.js.map